function filterOnlyCurrentWebsiteSharedAccesses(sharedAccessesObject:any, currentWebsiteId:number):any {
  // N.B.: we expect sharedAccessesObject not .items
  let listOfSharedAccessOfThisWebsiteOnly = sharedAccessesObject.items.filter(item => item.website === currentWebsiteId);
  return listOfSharedAccessOfThisWebsiteOnly;
}

export default filterOnlyCurrentWebsiteSharedAccesses;